import React, {createRef, useContext, useEffect} from "react"
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardMedia,
  IconButton,
  Button,
  Box,
  Link,
  Backdrop, CircularProgress
} from "@material-ui/core"
import {makeStyles} from "@material-ui/core/styles";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CloseIcon from "@material-ui/icons/Close";
import { useParams } from "react-router-dom";
import AudiobookService from "../service/audiobook";
import {IAudiobook, IStatLicenses} from "../models/audiobook";
import {IFindawayPlaylist, IFindawayPlaylistChapter} from "../models/findaway";
import FindawayService from "../service/findaway";
import {ProfileContext} from "../context/profile/profileContext";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme)=>({
  item: {
    flexGrow: 1,
  },
  media: {
    minHeight: 300,
    maxHeight: 480,
  },
  title: {
    fontSize: 14,
    paddingTop: 10
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    // margin: 15
  },
  cardContent: {
    flexGrow: 1,
  },
  cardMedia: {
    height: 0,
    paddingTop: '65%',
  },
  details: {
    paddingLeft: 34
  },
  playIcon: {
    height: 38,
    width: 38,
  },
  drawerHeaderLocal: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
    height: '100vh'
  },
  appBar: {
    position: 'relative',
  },
  titleModal: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  cardImg: {
    height: 300,
    width: 200,
  },
  modalContent: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  badge: {
    [theme.breakpoints.up('sm')]: {
      paddingRight: '10px'
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}))
let chapterIndex = 0
const PreviewCard = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const {profile} = useContext(ProfileContext)
  const {id} = useParams()
  const audioFile: any = createRef();
  const [isLoading, setIsLoading] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [isPlay, setIsPlay] = React.useState<boolean>(false);
  const [activeChapter, setActiveChapter] = React.useState<string>('');
  const [limiter, setLimiter] = React.useState<number>(0);
  const [chapters, setChapters] = React.useState<IFindawayPlaylistChapter[]>([]);
  const [audiobook, setAudiobook] = React.useState<IAudiobook | null>(null);
  const [license, setLicense] = React.useState<IStatLicenses | null>(null);

  const createMarkup = () => {
    if(audiobook) {
      return {__html: audiobook.attributes.description};
    }
    return {__html: ''};
  }
  const onBoard = () => {
    let data = window.localStorage.getItem('anyplayPreviewDone')
    if (data) {
      setIsOpen(true)
    } else {
      controlAudio()
    }
    // setIsOpen(true)
  }
  const onCloseModal = () => {
    setIsOpen(false)
  }
  useEffect(() => {
    if (profile) {
      getInfo()
    }
    // eslint-disable-next-line
  },[id, profile])

  useEffect(() => {
    postLicenses()
    // eslint-disable-next-line
  },[id, audiobook])

  useEffect(() => {
    if(license !== null && profile !== null) {
      getContent()
    }
    // eslint-disable-next-line
  },[license, profile])

  const postLicenses = async() => {
    if (audiobook && audiobook.attributes.audiobook_subscriptions.data.length !== 0) {
      try {
        let findawayId: string = audiobook?.attributes.book_id
        const data: IStatLicenses = await AudiobookService.postLicenses(findawayId)
        setLicense(data)
      } catch (e) {
        // alert.show(e.message, 'danger')
      }
    }
  }

  const getContent = async()=>{
    if(license && profile) {
      const data: IFindawayPlaylist = await FindawayService.getAudiobookPlaylists(
        {
          bookId:license?.attributes.book_id,
          licenseId:license?.attributes.license_id,
          sessionKey: profile?.attributes.session_key
        })
      setChapters(data.playlist)
      setActiveChapter(data.playlist[0].url)
    }
  }
  const getInfo = async ()=>{
    setIsLoading(true)
    try {
      let data = await AudiobookService.getAudiobook(id);
      setAudiobook(data)
      setIsLoading(false)
    } catch (e) {
      setIsLoading(false)
      console.log('getInfo -> e', e)
    }
  }

  const timeUpdate = async (e: any) => {
    if(limiter + e.target.duration >= 299) {
      if(limiter + e.target.currentTime >= 299) {
        window.localStorage.setItem('anyplayPreviewDone','Done')
        joinUs()
      }
    } else {
      if(e.target.duration < 299 && e.target.currentTime === e.target.duration ) {
        chapterIndex = chapterIndex + 1
        if(chapters[chapterIndex].url) {
          setLimiter(limiter+e.target.duration)
          await setActiveChapter(chapters[chapterIndex].url)
        } else {
          joinUs()
        }
      }
    }
  }
  const joinUs = () => {
    const audio:any = audioFile.current;
    audio.pause();
    setIsPlay(false)
    setIsOpen(true)
  }
  const controlAudio = () => {
    const audio:any = audioFile.current;
    if (audio.duration > 0 && !audio.paused) {
      // pause audio and stop counting
      audio.pause();
      setIsPlay(false)
    } else {
      // play audio
      audio.play();
      setIsPlay(true)
    }
  }
  useEffect(() => {
    if(limiter > 0) {
      controlAudio()
    }
    // eslint-disable-next-line
  },[activeChapter])
  useEffect(() => {
    let data = window.localStorage.getItem('anyplayPreviewDone')
    if (data) {
      setIsOpen(true)
    }
    // eslint-disable-next-line
  },[])
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.item}>
          <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
              <Grid container spacing={3} >
                <Grid item xs={12} sm={5} md={3}>
                  { audiobook?.attributes.cover_image_url ?
                    <CardMedia
                      className={classes.media}
                      image={audiobook?.attributes.cover_image_url}
                      title="cover_image_url"
                    />
                    : null
                  }
                  <br/>
                  <Grid container spacing={3} alignItems={"center"}>
                    <Grid item xs={8}>
                  <Button color="secondary"
                          variant="contained"
                          onClick={()=>setIsOpen(true)}>
                    {t('Try Anyplay')}
                  </Button>
                </Grid>
                    <Grid item xs={3}>
                  <audio
                    onTimeUpdate={timeUpdate}
                    src={activeChapter}
                    ref={audioFile}
                  />
                  <Button
                    aria-label="play/pause"
                    color="secondary"
                    variant="outlined"
                    disabled={activeChapter === ''}
                    onClick={onBoard}>
                    { isPlay ?
                      <PauseIcon className={classes.playIcon}/> :
                      <PlayArrowIcon className={classes.playIcon} />
                    }
                  </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={7} className={classes.details}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={3}>
                      <Typography className={[classes.title, 'blur-text'].join(' ')} >{t('Title')}:</Typography>
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <Typography className={classes.title}>{ audiobook?.attributes.title }</Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography className={[classes.title, 'blur-text'].join(' ')}>{t('Author')}:</Typography>
                    </Grid>
                    <Grid item xs={9} sm={9}>
                      <Typography className={classes.title}> { audiobook?.attributes.audiobook_authors.data.map(author => author.attributes.title).join(', ') } </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography className={[classes.title, 'blur-text'].join(' ')}>{t('Publisher')}:</Typography>
                    </Grid>
                    <Grid item xs={9} sm={9}>
                      <Typography className={classes.title}>{ audiobook?.attributes.publisher.data.attributes.title }</Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography className={[classes.title, 'blur-text'].join(' ')}>{t('Narrator')}:</Typography>
                    </Grid>
                    <Grid item xs={9} sm={9}>
                      <Typography className={classes.title}>{ audiobook?.attributes.audiobook_narrators.data.map(narrator => narrator.attributes.title).join(', ') }</Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography className={[classes.title, 'blur-text'].join(' ')}>{t('Language')}:</Typography>
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <Typography className={classes.title}> { audiobook?.attributes.language } </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography className={[classes.title, 'blur-text'].join(' ')}>{t('Date')}:</Typography>
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <Typography className={classes.title}>{ audiobook?.attributes.street_date.substring(0,4) }</Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography className={[classes.title, 'blur-text'].join(' ')}>{t('Playtime')}:</Typography>
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <Typography className={classes.title}>{ audiobook?.attributes.runtime }</Typography>
                    </Grid>
                    {/*<Grid item xs={12} sm={3}>*/}
                    {/*  <Typography className={[classes.title, 'blur-text'].join(' ')}>Average rating:</Typography>*/}
                    {/*</Grid>*/}
                    {/*<Grid item xs={12} sm={9}>*/}
                    {/*  <Typography className={classes.title}>4.7 based on 123456 votes</Typography>*/}
                    {/*</Grid>*/}
                      <Grid item xs={12} style={{paddingTop: '8px'}}>

                      </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={1} sm={12}/>
                <Grid item xs={11} sm={12}>
                  <Typography variant="h6" gutterBottom className={[classes.title, 'blur-text'].join(' ')}>
                    {t('Publisher description')}:
                  </Typography>
                  <Typography gutterBottom>
                    <div dangerouslySetInnerHTML={createMarkup()}/>
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Dialog fullScreen open={isOpen} onClose={onCloseModal} >
        <AppBar className={classes.appBar} >
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={()=>setIsOpen(false)} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.titleModal}>
              {t('Join Anyplay')}
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.drawerHeaderLocal} >
          <Grid container>
            <Grid item sm={1} md={2} lg={3}/>
              <Grid item xs={12} sm={4} md={3} lg={2} xl={2} >
                <Box display={{ xs: 'none', sm: 'block'}}>
                  <CardMedia
                    className={classes.cardImg}
                    image={require(`../assets/GenreScreenCircle-web.png`)}
                    title="Anyplay category"
                  />
                </Box>
              </Grid>
            <Grid item sm={6} md={5} className={classes.modalContent}>
              <Typography variant="h3">{t('Anytime')} {t('Anywhere')}</Typography>
              <Typography variant="h3">{t('For Anyone')}</Typography>
              <Typography >{t('We bring the best audio storytelling to every corner of the world')}</Typography>
              <br/>
              <Link className={classes.badge}
                    underline={"none"}
                    target="_blank"
                    href='https://apps.apple.com/al/app/anyplay-audiobooks-podcasts/id1445440724'>
                <img
                  style={{width:' 200px'}}
                  src={require("../assets/appstore-badge.png")}
                  alt="appstore"
                  data-src={require("../assets/appstore-badge.png")}
                  loading={'lazy'}
                />
              </Link>
              {/*<Link underline={"none"}*/}
              {/*      target="_blank"*/}
              {/*      href='https://apps.apple.com/al/app/anyplay-audiobooks-podcasts/id1445440724'>*/}
              {/*  <img style={{width:' 200px'}} src={require("../assets/google-play-badge.png")} alt="googlePlay"/>*/}
              {/*</Link>*/}
            </Grid>
          </Grid>

        </div>
      </Dialog>
      <Backdrop className={classes.backdrop} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  )
}
 export default PreviewCard
